import { FusionStores } from '@fusion/saas-components-v3'
import type { IFusionAuth } from '@fusion/auth-v3'

export const getLoggedInAsUser = () => {
  const store = FusionStores.loginas()
  return store ? store.getImpersonatedUser : {}
}

export const getUserAccountId = (auth: IFusionAuth) => {
  if (auth?.getAccountId) {
    const loggedInAsUser = getLoggedInAsUser()
    return loggedInAsUser?.accountId ?? auth.getAccountId()
  }

  return ''
}
